import React from 'react';
import { X } from 'lucide-react';

const DeleteScriptModal = ({ showDeleteModal, onConfirm, onCancel, isLoading = false }) => {
  if (!showDeleteModal) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[100] p-4 backdrop-blur-sm">
      <div className="bg-white rounded-[24px] w-full max-w-[480px] overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200">
        <div className="pt-6 pb-4 flex items-center justify-center relative">
          <h2 className="text-2xl lg:text-[28px] font-bold text-[#1C1917]">Are You Sure?</h2>
          <button
            onClick={onCancel}
            className="absolute right-5 top-5 w-8 h-8 flex items-center justify-center rounded-full border border-gray-200 text-gray-400 hover:text-gray-600 hover:bg-gray-50 transition-all shadow-sm"
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-8 pt-4 pb-6 text-center">
          <p className="text-[#57534E] text-base lg:text-lg mb-6">
            You're about to delete this script—this action cannot be undone.
          </p>

          <div className="flex flex-row justify-center gap-4">
            <button
              type="button"
              onClick={onCancel}
              disabled={isLoading}
              className="flex-1 py-3.5 border border-[#653600] text-[#653600] rounded-xl font-bold text-base hover:bg-[#653600]/5 transition-all min-w-[140px] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className="flex-1 py-3.5 bg-[#653600] text-white rounded-xl font-bold text-base hover:bg-[#4a2800] transition-all min-w-[140px] shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                  <span>Deleting...</span>
                </>
              ) : (
                'Delete'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteScriptModal;
